import * as STD        from '@emersya/mpa-std';
import * as BasketNS   from '@emersya/mpa-basket';
import * as CM         from '@emersya/mpa-components-manager';
import {
	Block,
	InputSelect,
	Text
}                      from '@emersya/mpa-components';
// import { Block, InputSelect, Image, Text } from '@libs/MPAComponents/index';
import ViewerComponent from '../../../Viewer/Viewer';

export interface IPlannerWallsEditorComponentConfiguration extends Block.Configuration {
	// translations : Record<string, STD.translationsManager.TranslationMapping>;
	forceBackgroundColor?: string | null;
	allFree?: boolean | null;
};

export class PlannerWallsEditorComponent extends Block.Component {
	readonly plannerCategory!: ViewerComponent.ProductCategory;

	get layoutId() {
		const currentProduct = app.currentProduct;
		if (!currentProduct) {
			return null;
		}
		const layoutPart = currentProduct.getPart(['layout']);
		if (!layoutPart) {
			return null;
		}
		const currentOption = layoutPart.currentOption;
		if (!currentOption) {
			return null;
		}
		return currentOption.id.replace('shape-', '');
	};

	get wallColorsBasketPart() {
		if (!app.currentProduct) {
			this.component_throwUserError('', {});
		}
		const part = app.currentProduct.parts.find(x => x.id === 'wall');
		if (!part) {
			this.component_throwLibraryError('', {});
		}
		return part;
	}

	async updateSize() {
		await app.viewer.freezeRendering({keepCount: true});
		for (const wallComponent of this.walls) {
			await wallComponent.viewerNodeUpdate();
		}
		await app.viewer.unfreezeRendering({keepCount: true});
	};

	async instantiateMenu(event: STD.events.Event<any, CM.Component<any, any>>) {
		const product = app.currentProduct;
		if (!product) {
			this.component_throwLibraryError('', {});
		}
		const wallPart = app.currentProduct.getPart(['wall']);
		const fieldContent = this.component_find('@:colorSelector:content');
		if (fieldContent.component_outerChilds.length) {
			for (const x of fieldContent.component_outerChilds) {
				await x.component_delete();
			}
			await wallPart.unuseOption();
		}
		void event;
		/** TODO : wall can be a configuration of the product object or a configuration of a specific wall object so the code should be updated. **/
		// if (app.currentProduct.hasPart(['layout'])) {
		// 	const layoutPart = app.currentProduct.getPart(['layout']);
		// 	const layoutOptionSKU = layoutPart?.currentOption?.reference?.value || null;
		// 	if (!fieldContent.component_outerChilds.length && layoutOptionSKU && layoutOptionSKU !== 'shape-no-wall') {
		// 		const defaultWallColorSKU = app.currentDefaults.wall;
		// 		const wallOptionsDescriptors = app.component_configuration.productsOptions.filter(x => x.component === 'wall');
		// 		if (!wallOptionsDescriptors) {
		// 			this.component_throwUserError('', {});
		// 		}
		// 		const inputSelect = <InputSelect.Component>await fieldContent.component_instantiateOuterChild<InputSelect.Configuration>(
		// 			{
		// 				type: 'input-select',
		// 				id: 'options',
		// 				tree: this.component_tree,
		// 				slot: null,
		// 				isSlot: false,
		// 				configuration: {
		// 					'renderingMode': 'radio',
		// 					defaultValue: defaultWallColorSKU || null,
		// 					'@isDisabled': !wallOptionsDescriptors.length
		// 				}
		// 			}
		// 		);
		// 		await app.fillComponentOptions(
		// 			this,
		// 			wallPart,
		// 			inputSelect,
		// 			wallOptionsDescriptors,
		// 			'viewer-planner-walls-optionTile',
		// 			event
		// 		);
		// 		await inputSelect.component_initialize();
		// 		if (wallOptionsDescriptors.length) {
		// 			await inputSelect.component_start(event);
		// 		}
		// 		let checkOptions = false;
		// 		const optionsEnabled = app.component_configuration.productsOptions.filter(x => x.component ===
		// 			'wall' &&
		// 			x.products.includes(product.id));
		// 		for (const children of inputSelect.component_outerChilds) {
		// 			if (optionsEnabled.find(x => x.SKU === children.id) && children.component_isDisabled) {
		// 				checkOptions = true;
		// 				await children.component_enable();
		// 			} else if (!optionsEnabled.find(x => x.SKU === children.id)) {
		// 				await children.component_disable();
		// 			} else {
		// 				checkOptions = true;
		// 			}
		// 		}
		// 		const fieldHeader = this.component_find('@:colorSelector:header');
		// 		if (checkOptions) {
		// 			await fieldHeader.component_enable();
		// 		} else {
		// 			await fieldHeader.component_disable();
		// 		}
		// 	}
		// } else {
		// 	const defaultWallColorSKU = app.currentDefaults.wall;
		// 	const wallOptionsDescriptors = app.currentOptions.filter(x => x.component === 'wall');
		// 	const header = this.component_find('@:colorSelector:header');
		// 	if (wallOptionsDescriptors.length === 0) {
		// 		await header.component_disable();
		// 		return;
		// 	}
		// 	await header.component_enable();
		// 	const inputSelect = <InputSelect.Component>await fieldContent.component_instantiateOuterChild<InputSelect.Configuration>(
		// 		{
		// 			type: 'input-select',
		// 			id: 'options',
		// 			tree: this.component_tree,
		// 			slot: null,
		// 			isSlot: false,
		// 			configuration: {
		// 				'renderingMode': 'radio',
		// 				defaultValue: defaultWallColorSKU || undefined,
		// 				'@isDisabled': !wallOptionsDescriptors.length
		// 			}
		// 		}
		// 	);
		// 	const allFree = (<IPlannerWallsEditorComponentConfiguration>this.component_configuration).allFree;
		// 	await app.fillComponentOptions(
		// 		this,
		// 		wallPart,
		// 		inputSelect,
		// 		wallOptionsDescriptors,
		// 		'viewer-planner-walls-optionTile',
		// 		event,
		// 		allFree
		// 	);
		// 	await inputSelect.component_initialize();
		// 	if (wallOptionsDescriptors.length) {
		// 		await inputSelect.component_start(event);
		// 	}
		// }
		STD.translationsManager.update(this.component_DOM);
	};

	get walls() {
		const menuAccordion = this.component_find('@:menu');
		return <PlannerWallsProductTileNS.Component[]>menuAccordion.component_outerChilds;
	};

	async updateLayout() {
		if (!app.basket || !app.basket.basket.currentProduct) {
			return;
		}
		const selectedLayout = app.basket.basket.currentProduct.getPart(['layout']).currentOption?.id.replace('shape-', '');
		for (const wallComponent of this.walls) {
			await wallComponent.viewerNodeRemove();
		}
		await this.instantiateMenu(this.component_getEventWhichRepresentNoEvent());
		if (selectedLayout && (selectedLayout !== 'no-wall')) {
			for (const wallComponent of this.walls) {
				if (selectedLayout.includes(wallComponent.id)) {
					await wallComponent.viewerNodeInsert();
				}
			}
		}
	};

	async update() {
		if (!this.layoutId) {
			return;
		}
		await app.viewer.freezeRendering({keepCount: true});
		await this.updateLayout();
		await this.updateSize();
		await app.viewer.unfreezeRendering({keepCount: true});
	};

	async clear() {
		if (app.isReloading) {
			return;
		}
		for (const wallComponent of this.walls) {
			await wallComponent.viewerNodeRemove();
		}
	};

	async onColorValueUpdated() {
		const select = <InputSelect.Component>this.component_find('@:colorSelector:content.options');
		const option = select.value;
		if (!app.basket || !app.currentProduct) {
			this.component_throwLibraryError('', {});
		}
		const wallPart = app.currentProduct.getPart(['wall']);
		if (!option) {
			if (wallPart.currentOption) {
				await wallPart.unuseOption();
			}
		} else {
			if (wallPart.currentOption && wallPart.currentOption.id === option.id) {
				return;
			}
			await wallPart.useOption(option.id);
		}

	};

	private async initializeProduct(product: BasketNS.Product) {
		const part = product.createPart({
			id: 'wall',
			title: 'Wall',
			reference: null,
			metaData: null,
			parts: [],
			options: []
		});
		await part.initialize();
	};

	override async component_initialize() {
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('', {});
		}
		for (const product of app.basket.basket.products) {
			await this.initializeProduct(product);
		}
	};

	getConfiguratorMenu(event: STD.events.Event<any, any>) {
		const product = <ViewerComponent.ProductInstance>event.details.product;
		const wallId = product.metadata.id;
		const wall = this.walls.find(x => x.id === wallId);
		if (!wall) {
			return;
		}
		return wall.getMenuConfigurator();
	};

	override async component_start(startEvent: STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		const wallProductNodeComponents = app.component_configuration.PMS.objects.filter(x => x.type === '@wall');
		const editor = this;
		void editor;
		const viewerCustomPatchProductNodeComponents = app.component_configuration.PMS.objects.find(x => x.type ===
			'@viewerCustomPatch');
		if (!viewerCustomPatchProductNodeComponents) {
			this.component_throwUserError('No "@viewerCustomPatch" component defined!', {});
		}
		(<any>this).plannerCategory = app.viewer.createCategory({
			name: 'Wall',
			menuActions: {
				edit: true,
				delete: false,
				rotate: false,
				duplicate: false
			},
			products: wallProductNodeComponents.reduce<ViewerComponent.Product.IDescriptor[]>((a, c) => {
				for (const productSKU of c.context.forProducts) {
					const wallSKU = `@wall-${productSKU}`;
					const productDescriptor: ViewerComponent.Product.IDescriptor = {
						SKU: wallSKU,
						nodes: [
							{
								localId: 'global',
								SKU: <string>c.SKU,
								projectCode: <string>c.d3.projectCode,
								parentLocalId: 'root',
								doNotListAsProductComponent: true,
								tracked: true,
								draggable: false,
								matrix: app.viewer.mtx(
									[0, 0, 0],
									[1, 1, 1],
									0
								)
							}
						]
					};
					app.viewer.productsExtensionById[wallSKU] = {
						quantity: null,
						configuratorGet: CM.PropertyOperation.CallOperation.create({
							type: 'call',
							componentPath: this.component_getPath(),
							propertyPath: 'getConfiguratorMenu',
							parameters: []
						})
					};
					a.push(productDescriptor);
				}
				return a;
			}, [])
		});
	};

	private async onNewProduct(event: STD.events.Event<any, CM.Component<any, any>>) {
		const product = event.details.product;
		await this.initializeProduct(product);
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IPlannerWallsEditorComponentConfiguration
	) {
		configuration['@innerConfigurations'] = {
			header: <Block.Configuration>{
				'@innerConfigurations': {
					label: <Text.Configuration>{
						'@translations': {
							text: configuration['@translations']?.label
						}
					}
				}
			},
			menu: {
				'@innerConfigurations': {
					left: <PlannerWallsProductTileNS.Configuration>{
						forceBackgroundColor: configuration.forceBackgroundColor,
						'@translations': {
							title: configuration['@translations']?.left
						}
					},
					right: <PlannerWallsProductTileNS.Configuration>{
						forceBackgroundColor: configuration.forceBackgroundColor,
						'@translations': {
							title: configuration['@translations']?.right
						}
					},
					back: <PlannerWallsProductTileNS.Configuration>{
						forceBackgroundColor: configuration.forceBackgroundColor,
						'@translations': {
							title: configuration['@translations']?.back
						}
					}
				}
			}
		};
		super(descriptor, configuration);
		void this.onNewProduct;
	};
};
export namespace NS {
	export const Component = PlannerWallsEditorComponent;
	export type Component = PlannerWallsEditorComponent;
	export type Configuration = IPlannerWallsEditorComponentConfiguration;
}

import manifestXMLSource                   from './PlannerWallsEditor.xml';
import './PlannerWallsEditor.scss';
import { NS as PlannerWallsProductTileNS } from '../ProductTile/PlannerWallsProductTile';
// import { NS as PlannerWallsOptionTileNS }  from '../OptionTile/PlannerWallsOptionTile';

CM.Manager.declare({
	id: 'viewer-planner-walls-editor',
	type: PlannerWallsEditorComponent,
	manifest: manifestXMLSource
});
